module.exports = __webpack_public_path__ + "img/Review.b1212757.png";